import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Animated } from "react-animated-css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Container, Row, Col } from "reactstrap";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
class AboutUs extends Component {
  render() {
    return (
      <div>
        <Animated
          animationInDelay={100}
          animationIn="bounceInLeft"
          animationOut="bounceInRight"
          isVisible
        >
          <Navbar />
        </Animated>
        <Container>
          <div style={{ display: "inline-block" }} className="cd m-t500 g--4 g--4--sl">
            <div
              className="cd-ic"
              style={{
                backgroundImage: "url(./tastysinsbyari.jpg)",
                padding: "45%",
              }}
            />
          </div>
          <div class="b b-- b--fw">
            <div class="b-c">
              <div class="sh ">
                <h2 class="sh-title">Tasty Sins By Ari</h2>
              </div>
            </div>
          </div>
          <Row>
            <Col xs="3" />
            <Col />
            <Col xs="auto">
              <Animated
                animationInDelay={0}
                animationIn="slideInUp"
                animationOut="slideOutDown"
                isVisible
              >
                <div class="cd-c">
                  <div className="ta-c p-h200 t--intro">
                    Hi everyone and welcome to Tasty Sins by Ari, I go by my nick name but
                    Ariuna is my full name pronounced Ariana! I have a very active 3 yr.
                    old and work full time in the healthcare industry. Aside from loving
                    food I love to create; I got into this industry around Valentine’s day
                    when I was wanted to create gift boxes for my single friends in order
                    to receive LOVE on this special day and here we are 2020 and I have
                    created cakes, cookies, still continue to create gift boxes for my
                    friends.
                  </div>
                  <br />
                  <br />
                  <br />
                  <div
                    className="cd-ic"
                    style={{
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundImage: "url(./6.jpg)",
                      paddingBottom: "29%",
                      margin: "1em",
                    }}
                  />
                  <br />
                  <p className="ta-c p-h200 t--intro">
                    {" "}
                    I enjoy what I do and the taste that it leaves within individuals
                    lives or even the expression they get once they look inside that box
                    and see how their vision turned out with mine! Whether it be a
                    birthday, anniversary or just a sweet tooth craving my pleasure is
                    always to serve you !
                  </p>
                  <a href="https://www.instagram.com/tastysinsbyari/" target="_blank">
                    <FontAwesomeIcon
                      className="fontIcon"
                      icon={faInstagram}
                      size="5x"
                      style={{ margin: "1% 45%" }}
                    />
                  </a>
                </div>
              </Animated>
            </Col>
            <Col xs="3" />
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default AboutUs;
